import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import IconMail from '../../images/common/icon_mail.png';
import IconMail2x from '../../images/common/icon_mail@2x.png';
import ConfirmModal from './ConfirmModal';
import { UserType } from '../../types';

type EmailProps = {
  userType: UserType;
}

const Email = (props: EmailProps) => {
  const userType = props.userType;

  const [ showModal, setShowModal ] = useState(false);
  const [ initial, setInitial ] = useState("");
  const [ email, setEmail ] = useState("");
  const [ password, setPassword ] = useState("");

  const hideModal = () => {
    setShowModal(false);
  }

  const formatInitial = (e: React.FocusEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setInitial(val.slice(0,2).toUpperCase());
  }

  const validateInput = () => {
    const regInitial = /^[A-Z]{2}$/;
    const regEmail = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
    const regPassword = /^[a-zA-Z0-9\-_@?!$%&]{8,100}$/;

    return regInitial.test(initial) && regEmail.test(email) && regPassword.test(password);
  }

  return (
    <section>
      <h2 className="curve_title">
        <img
          src={ IconMail }
          srcSet={ `${ IconMail } 1x, ${ IconMail2x } 2x` }
          alt="メールアドレスで新規登録"
        />
        メールアドレスで新規登録
      </h2>
      <p>18歳未満の方はご利用になれません。</p>
      <div className="form">
        <dl className="graf_list">
          <dt>イニシャル</dt>
          <dd>
            <input
              type="text"
              value={ initial }
              maxLength={ 2 }
              onChange={ e => setInitial(e.target.value) }
              onBlur={ e => formatInitial(e) }
              placeholder="TB"
            />
          </dd>
          <dt>メールアドレス</dt>
          <dd>
            <input
              type="text"
              value={ email }
              onChange={ e => setEmail(e.target.value) }
              placeholder="info@tonbebe.jp"
            />
          </dd>
          <dt>パスワード</dt>
          <dd>
            <input
              type="password"
              value={ password }
              onChange={ e => setPassword(e.target.value) }
              placeholder="半角英数記号8文字以上"
            />
          </dd>
        </dl>
        <p><Link to="/terms" className="colored" target="_blank">利用規約</Link>に同意の上、新規登録してください。</p>
        <button
          className={ userType === UserType.Donee ? "w_pinkbtn" : "w_bluebtn" }
          type="submit"
          disabled={ !validateInput() }
          onClick={ () => setShowModal(true) }
        >
          新規登録内容確認
        </button>
      </div>
      { showModal &&
          <ConfirmModal
            userType={ userType }
            hideModal={ hideModal }
            initial={ initial }
            email={ email }
            password={ password }
          />
      }
    </section>
  );
}

export default Email;
